import { render, staticRenderFns } from "./TeamRoleCard.vue?vue&type=template&id=8941f65c&scoped=true&"
import script from "./TeamRoleCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamRoleCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamRoleCard.vue?vue&type=style&index=0&id=8941f65c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8941f65c",
  null
  
)

export default component.exports